import { render, staticRenderFns } from "./PT405MemberInfoTdkParts.vue?vue&type=template&id=30c0bab2&"
import script from "./PT405MemberInfoTdkParts.vue?vue&type=script&lang=js&"
export * from "./PT405MemberInfoTdkParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports